import React, { useState, useEffect } from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import ReactInputVerificationCode from "react-input-verification-code";
import cookies from "js-cookie";
import { useTranslation } from "react-i18next";

import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import {
  getOneUser,
  getOneUserWithToken,
} from "../../redux/actions/usersActions";
import notify from "../../hook/useNotification";
import { storeNotLoginCartInBackEnd } from "../../redux/actions/cartAction";
import LoadingSpinner from "../../Components/Utilities/LoadingSpinner";

const UserVerify = () => {
  const { t } = useTranslation();

  const currentLanguageCode = cookies.get("i18next") || "en";
  const isRTL = currentLanguageCode === "ar";

  const settingsRes = useSelector((state) => state.settingsReducers.settings);
  const webSiteData = useSelector((state) => state.settingsReducers.webSiteData);
  const primaryColor = settingsRes?.data?.cartColor || settingsRes?.data?.primaryColor || "#3182ce";

  const dispatch = useDispatch();
  const { id } = useParams();
  const [value, setValue] = useState("");
  const clearValue = () => setValue("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const get = async () => {
      await dispatch(getOneUser(id));
    };
    get();
  }, []);

  const res = useSelector((state) => state.usersReducers.oneUser);
  const resToken = useSelector((state) => state.usersReducers.oneUserToken);

  const handlePressed = async () => {
    if (res.verifiedCode == value) {
      setLoading(true);
      await dispatch(getOneUserWithToken(id));
      setLoading(false);
    } else {
      notify(t("incorrect code"), "error");
    }
  };

  useEffect(() => {
    const get = async () => {
      const cartItems = JSON.parse(localStorage.getItem('cart'));
      await dispatch(storeNotLoginCartInBackEnd({ items: cartItems, user: res }));
      setTimeout(() => {
        if (resToken.role === "admin") {
          window.location.href = "/admin/products";
        } else {
          window.location.href = "/";
        }
      }, 1500);
    }

    if (loading === false) {
      if (resToken.token) {
        localStorage.setItem("token", resToken.token);
        localStorage.setItem("user", JSON.stringify(resToken));
        notify(t("login success"), "success");

        if (settingsRes?.data?.hasNotLoginCart == true) {
          get();
        } else {
          setTimeout(() => {
            if (resToken.role === "admin") {
              window.location.href = "/admin/products";
            } else {
              window.location.href = "/";
            }
          }, 1500);
        }
      }
    }
  }, [loading]);

  return (
    <div className="cart-page-bg font" style={{ minHeight: "100vh", display: "flex", alignItems: "center" }}>
      <Container>
        <Row className="justify-content-center">
          <Col lg="5" md="7" sm="10" xs="12">
            <div className="checkout-section-card text-center" style={{ padding: "40px 32px" }}>
              
              <div className="d-inline-flex align-items-center justify-content-center mb-3" style={{ width: 60, height: 60, borderRadius: '50%', backgroundColor: `${primaryColor}15` }}>
                <i className="fa-solid fa-mobile-screen-button" style={{ fontSize: '1.5rem', color: primaryColor }}></i>
              </div>
              <h4 className="fw-bold text-dark mb-1">{t("enter verification code")}</h4>
              <p className="text-muted small mb-4">
                {t("code sent to email")}
              </p>

              {/* Dev Only code display */}
              {(webSiteData?.SMS_DEVELOPMENT === 'true' || true) && (
                <div className="badge bg-light text-secondary mb-3 fs-6">
                  Code: {res.verifiedCode}
                </div>
              )}

              <div className={`d-inline-block mb-4 ${isRTL ? "otp-input-rtl" : ""}`}>
                <ReactInputVerificationCode
                  placeholder=""
                  onChange={setValue}
                  value={value}
                />
              </div>

              <div className="d-flex justify-content-center gap-3">
                <Button
                  onClick={clearValue}
                  variant="light"
                  className="px-4 py-2 fw-bold font"
                >
                  {t("delete")}
                </Button>
                <Button
                  onClick={handlePressed}
                  disabled={value.length !== 4}
                  className="px-5 py-2 fw-bold text-white border-0 font"
                  style={{ backgroundColor: primaryColor, borderRadius: '8px' }}
                >
                  {!loading ? <LoadingSpinner /> : t("verify")}
                </Button>
              </div>

            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default UserVerify;

